import Typography from "@mui/material/Typography";
import PaidIcon from "@mui/icons-material/Paid";
import Button from "@mui/material/Button";
import { LoadingListEntityProfile, PaginationList } from "Explore/Components";
import { getAuthorAwardsByID } from "Explore/Services/Author";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Empty, Tag } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./FacultyAwards.module.scss";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";
const Award = ({ award }) => {
  return (
    <div className={styles["award"]}>
      <div
        className={styles["title"]}
        onClick={() => {
          if (award.award_url) {
            window.open(award.award_url);
          }
        }}
      >
        <span>
          <b>{award.award_title}</b>
        </span>
        {award.program_title !== "None" && (
          <span className={styles["venue"]}>
            <i>. {award.program_title}</i>
          </span>
        )}
      </div>
      <div className={styles["award-number"]}>
        <span>
          <span className={styles["section-title"]}>Award number:</span>
          <span style={{ fontStyle: "italic" }}>
            {" "}
            {award.award_number}
          </span>.{" "}
        </span>
      </div>

      <div className={styles["award-number"]}>
        <span style={{ color: "var(--explore-color)", fontWeight: "500" }}>
          {award.start_date} / {award.end_date}
        </span>
      </div>
      <div className={styles["sponsors"]}>
        <span className={styles["section-title"]}>Sponsors:</span>{" "}
        {award.sponsors &&
          award.sponsors.map((item, index) => {
            return <span key={index}>{item["#text"]}; </span>;
          })}
      </div>
      <div className={styles["coauthors"]}>
        <span>
          <span className={styles["section-title"]}>
            Principal investigators:
          </span>{" "}
          {award.principal_investigators}
        </span>
      </div>
      <div className={styles["dates"]}>
        <p></p>
      </div>
      <div className={styles["tags"]}>
        {award.keywords.map((item, index) => {
          return (
            <Tag
              key={index}
              color="var(--light-blue)"
              style={{ cursor: "pointer" }}
            >
              {item.id}
            </Tag>
          );
        })}
      </div>
      <div className={styles["action"]}>
        {/* {award.amount_awarded != 0 && (
          <Button
            style={{
              backgroundColor: "white",
              color: "#b45f06",
              borderRadius: 10,
              height: 25,
              paddingLeft: 0,
              textAlign: "left",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            <PaidIcon />
            <Typography align={"left"} style={{ fontSize: 12 }}>
              {numberRegex(parseFloat(award.amount_awarded))}
            </Typography>
          </Button>
        )} */}
      </div>
    </div>
  );
};
const FacultyAwards = ({ tab, selectedKeywords, sliderValue }) => {
  const { isAuthLoading, userTypeConfig } = useAuth({
    entityType: "FACULTY",
  });
  const faculty_id = useLocation().pathname.split("/")[3];
  const [data, setData] = useState({ data: [], isLoading: true });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    hasMore: true,
  });
  const [showLoginSection, setShowLoginSection] = useState(false);

  useEffect(() => {
    if (tab === "grants" && !isAuthLoading) {
      setData({ ...data, isLoading: true });
      getAuthorAwardsByID(
        faculty_id,
        pagination.page - 1,
        pagination.rowsPerPage,
        sliderValue,
        selectedKeywords,
        (res) => {
          setData({ data: res.awards, isLoading: false });
          if (res.total >= 0) {
            setPagination({ ...pagination, totalRows: res.total });
          }
        },
        (err) => {
          if (err?.response?.status === 401) {
            setShowLoginSection(true);
          }
          setData({ data: [], isLoading: false });
        }
      );
    }
  }, [
    faculty_id,
    pagination.page,
    pagination.rowsPerPage,
    selectedKeywords,
    sliderValue,
    tab,
    isAuthLoading,
  ]);
  return (
    <div className={styles["faculty-awards"]}>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data.length > 0 ? (
            data?.data.map((item, index) => {
              return <Award award={item} key={index} />;
            })
          ) : showLoginSection ? (
            <LoginRequiredSection />
          ) : (
            <Empty description="No Award Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={false}
      />
      <PaginationList
        pagination={pagination}
        setPagination={setPagination}
        sizeChanger={userTypeConfig.ui_components.pageSizeChanger}
      />
    </div>
  );
};

export default FacultyAwards;
